
<template>
    <div  class="footerBottom">
      <div class="flx-center">
      <div class="platformBackground" :style="{ background: 'url(' + $ossUrl + 'images/head_img3.jpg) no-repeat center' }"></div>
    </div>
      <div class="platform">
        <!-- 美通海外仓 -->
        <div class="container" >
          <div class=" button-group">
              <div class="button-group-item"  style="position: absolute;top:800px;">
                <el-button
                 v-for="(item, index) in buttons"
                 :key="index"
                 :class="{ 'active': activeIndex === index }"
                 @click="setActive(item,index)"
               >
                 <div class="btn-text" style="">
                  {{ item.label }}
                </div>
               </el-button>
              </div>
             </div>
             <div class="tab-content">
              <el-row  :gutter="37">
                <el-col :span="2.4" v-for="(item, index) in buttonWarehouse" :key="index">
                  <el-button
                     :class="{ 'activeWarehouse': activeWarehouseIndex === index }"
                     class="flx-center"
                     @click="activeWarehouseIndex = index"
                   >
                 <div class="btn-warehouse" style="">
                  {{ item.label }}
                </div>
               </el-button>
                </el-col>
              </el-row>
            
             </div>
             <div class="echartBox flx-align-start ">
              <div >
                <Germany v-if="activeWarehouseIndex === 0"></Germany>
                <France v-else-if="activeWarehouseIndex === 1"></France>
                <Britain v-else-if="activeWarehouseIndex === 2"></Britain>
                <Japan v-else-if="activeWarehouseIndex === 3"></Japan>
                <Canada v-else-if="activeWarehouseIndex === 4"></Canada>
                <Spain v-else-if="activeWarehouseIndex === 5"></Spain>
                <Italy v-else-if="activeWarehouseIndex === 6"></Italy>
                <Poland v-else-if="activeWarehouseIndex === 7"></Poland>
                <CzechRepublic v-else-if="activeWarehouseIndex === 8"></CzechRepublic>
                <America v-else-if="activeWarehouseIndex === 9"></America>
              </div>
              <div >
                <div class="scrolling-list">
                  <div class="scrolling-list-header">慕尼黑</div>
                  <div class="scrolling-list-content">
                    <div class="scrolling-list-group">
                      <div class="group-title">B</div>
                      <el-row>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                      </el-row>
                   
                    </div>
                    <div class="scrolling-list-group">
                      <div class="group-title">B</div>
                      <el-row>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                        <el-col :span="12">
                          <div class="group-list">B1</div>
                        </el-col>
                      </el-row>
                   
                    </div>
                    <!-- 重复以上结构以展示更多组 -->
                  </div>
                </div>
              </div>
             </div>
          </div>
        
      </div>
    </div>
  </template>
  <script>
  
  import Germany from './components/country/Germany.vue';
  import France from './components/country/France.vue';
  import Britain from './components/country/Britain.vue';
  import Japan from './components/country/Japan.vue';
  import Canada from './components/country/Canada.vue';
  import America from './components/country/America.vue';
  import Spain from './components/country/Spain.vue';
  import Italy from './components/country/Italy.vue';
  import Poland from './components/country/Poland.vue';
  import CzechRepublic from './components/country/CzechRepublic.vue';
  /**
   * Index-1 component
   */
  export default {
      name:"sea",
    components: {
      Germany,
      France,
      Britain,
      Japan,
      Canada,
      America,
      Spain,
      Italy,
      Poland,
      CzechRepublic
    },
    data(){
      return {
        activeName:'first',
        activeIndex: 1, // 默认选中第一个按钮
        buttons: [
          { label: '亚马逊仓库地址',transportMode:'OCEAN' },
          // { label: '仓库地址分布图',transportMode:'AIR' },
          { label: 'AMAZON注册',transportMode:'RAIL' }
        ],
        activeWarehouseIndex: 1,
        buttonWarehouse: [
          { label: '德国',transportMode:'OCEAN' },
          { label: '法国',transportMode:'AIR' },
          { label: '英国',transportMode:'RAIL' },
          { label: '日本',transportMode:'RAIL' },
          { label: '加拿大',transportMode:'RAIL' },
          { label: '西班牙',transportMode:'RAIL' },
          { label: '意大利',transportMode:'RAIL' },
          { label: '波兰',transportMode:'RAIL' },
          { label: '捷克',transportMode:'RAIL' },
          { label: '美国',transportMode:'RAIL' },
        ],
       
      }
    },
    methods: {
      setActive(item,index) {
        if(index === 0){
          this.$router.push({
            name:'platform'
          })
        }
        else if(index === 1){
          this.$router.push({
            name:'AMAZON'
          })
          // this.$router.push({
          //   name:'warehouseMap'
          // })
        }
        // else if(index === 2){
        //   this.$router.push({
        //     name:'AMAZON'
        //   })
        // }
        // this.activeIndex = index;
        
  
      },
    }
  };
  </script>
<style src="../index.css" scoped>
  
  
  </style>